import styled from 'styled-components';
interface TtsProps {
  isMobile?: boolean;
}

export const TtsContainer = styled.div<TtsProps>`
  display: flex;
  flex-direction: column;
  padding: ${({ isMobile }: {isMobile: any}) => (isMobile ? '2rem 1rem 1rem' : '2rem')};
  gap: 1rem;
  background: ${({ theme }: {theme: any}) => theme.neutralLighter};
  border-radius: 1rem;
  width: 100%;
  height: ${({ isMobile }: {isMobile: any}) => (isMobile ? '100%' : 'initial')};
`;

export const TtsHeader = styled.header<TtsProps>`
  position: relative;
  display: flex;
  justify-content: ${({ isMobile }: {isMobile: any}) => (isMobile ? 'center' : 'space-between')};
  padding: ${({ isMobile }: {isMobile: any}) => (isMobile ? '0 0 12px' : '0 20px 20px')};

  .title {
    display: flex;
    flex-direction: ${({ isMobile }: {isMobile: any}) => (isMobile ? 'column' : 'flex')};
    gap: ${({ isMobile }: {isMobile: any}) => (isMobile ? '0.2rem' : '1rem')};

    h1 {
      font: 700 1.5rem/1.8rem 'Roboto', sans-serif;
      color: ${({ theme }: {theme: any}) => theme.black};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 300px;
    }

    h2 {
      border-left: ${({ isMobile }: {isMobile: any}) =>
        isMobile ? 'none' : '1px solid #dfdfdf'};
      padding-left: ${({ isMobile }: {isMobile: any}) => (isMobile ? '0' : '12px')};
      text-align: ${({ isMobile }: {isMobile: any}) => (isMobile ? 'center' : 'initial')};
      font: 400 0.9rem/1.8rem 'Roboto', sans-serif;
      color: ${({ theme }: {theme: any}) => theme.neutralSecondary};
    }
  }

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 4px;
    border-radius: 16px;
    left: 0;
    bottom: 0;
    opacity: 0.1;
    background: ${({ theme }: {theme: any}) => theme.black};
  }
`;
